import Dropdown from 'react-dropdown'
import {lfoShapeOptions, getLFOShapeOption} from './lfo-shape-constants.js';
import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const LFOShapeDropdown = (props) => { 

    const onSelectLFOShape = (o) => {
        props.lfo.lfoType = o.value;
    };
    return (
        <div className="osc-type-dropdown-container">
          <Dropdown
            className='osc-type-dropdown'
            controlClassName='osc-type-control-dropdown'
            arrowClassName='osc-type-arrow-dropdown'
            options={lfoShapeOptions}
            onChange={onSelectLFOShape}
            value={getLFOShapeOption(props.lfo.lfoType)}
            placeholder="LFO" />
          <div className="clear-fix"/>
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      lfoType: props.lfo.lfoType
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LFOShapeDropdown);
